import styled, { css } from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Button, { BUTTON_VARIANTS } from '@common/components/Button';

const fixedButtonStyles = (theme, isSmall) => css`
  display: flex;
  justify-content: center;

  ${isSmall
    ? css`
        width: 4rem;
        height: 4rem;
        padding: 0;

        svg {
          width: 1.6rem;
          height: 1.6rem;
          transform: scale(1);
        }
      `
    : ``}
`;

const fluidButtonStyles = (theme, isSmall) => css`
  width: auto;
  height: auto;

  ${isSmall
    ? css`
        ${theme.getFluidSpacing('padding', 'equal', 6)};
        transform: scale(1.1);
      `
    : css`
        ${theme.getFluidSpacing('padding', 'equal', 5)};
        transform: scale(1.5);
      `}

  svg {
    transform: scale(1.5);
  }
`;

const buttonSizeStyles = ({ theme, isFixed, isSmall }) =>
  isFixed
    ? fixedButtonStyles(theme, isSmall)
    : fluidButtonStyles(theme, isSmall);

export const CrossButton = styled(Button).attrs({
  variant: BUTTON_VARIANTS.LEVEL_2_BLUEGREY_90_SMALL,
})`
  ${buttonSizeStyles}
  ${({ isWhite }) =>
    isWhite &&
    css`
      border-color: ${getThemeColor('grey.100')};
      background-color: ${getThemeColor('grey.100')};
    `}
  box-shadow: ${({ hasShadow, theme }) => hasShadow && theme.shadows[1]};
  border-radius: ${({ theme }) => theme.borderRadiuses.pill}rem;

  span {
    pointer-events: none;
  }
`;
